import { authProvider } from "../context/authProvider";
import { useLocation } from "react-router-dom";
import { OktaIDP, AuthenticationState } from "../components/OktaIDP";
import { TableReportesUsabilidad } from "../components/TableReporteUsabilidad";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";
import "../theme/ReporteCierreDia.css";

/** Reporte de usabilidad */
export const ReporteUsabilidadPage = () => {
  const { state } = useLocation();

  return (
    <OktaIDP provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div>
              <div className="title-name-admin">
                <div className="icon-goback-title-admin">
                  <BtnGoBack caption={state.dataRouter[0].FCSEGUNDASECCION} />
                </div>
              </div>
              <div className="box-table-contantent-reportes">
                <TableReportesUsabilidad />
              </div>
            </div>
          );
        }
      }}
    </OktaIDP>
  );
};
